import { useServer } from 'Shared/SiteProvider';
import { PageMeta } from 'Shared/frontend/PageMeta';
import { createResource } from 'solid-js';
import { initPageDetails } from 'Shared/frontend/PageDetailsProvider';
import { Reveal } from 'Shared/frontend/Reveal';
import { LayoutComponents } from 'Shared/frontend/widgets/LayoutComponents';
import { useLocation } from '@solidjs/router';
import { useSettings } from 'Shared/frontend/SettingsProvider';
import { initPageStyles } from 'Shared/frontend/widgets/StylesProvider';

const pageName = 'frontend/Custom';

export default function CustomPage()
{
	const location = useLocation();
	const pages = useSettings().pages(); 

	const config = () => pages.find(e => e.frontend.route == location.pathname)

	const [data] = createResource(() => useServer().read.query({page:pageName,permission:'page',params:{name:config().key}}));

	initPageDetails(`${pageName}/${config().key}`,'page','Page-image');

	return (
		<Reveal when={data()}>
			<Contents config={config()} data={data()} />
		</Reveal>
	);
}

function Contents(P)
{
	initPageStyles(P.data);

	return (<>
		<PageMeta title={P.config.frontend.metaTitle} />
		<LayoutComponents layout={P.data.layout} />
	</>);
}

